"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Growthbook = void 0;
var growthbook_1 = require("@growthbook/growthbook");
var RudderAnalytics = __importStar(require("rudder-sdk-js"));
var Growthbook = /** @class */ (function () {
    // we have to pass settings due the specific framework implementation
    function Growthbook(clientKey, decryptionKey) {
        this.GrowthBook = new growthbook_1.GrowthBook({
            apiHost: 'https://cdn.growthbook.io',
            clientKey: clientKey,
            decryptionKey: decryptionKey,
            subscribeToChanges: true,
            enableDevMode: window === null || window === void 0 ? void 0 : window.location.hostname.includes('localhost'),
            trackingCallback: function (experiment, result) {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'experiment_viewed',
                        event_category: 'experiment',
                        rudder_anonymous_id: RudderAnalytics.getAnonymousId(),
                        experiment_id: experiment.key,
                        variation_id: result.variationId,
                    });
                }
                RudderAnalytics.track('experiment_viewed', {
                    experimentId: experiment.key,
                    variationId: result.variationId,
                });
            },
        });
        this.init();
    }
    // for make instance by singleton
    Growthbook.getGrowthBookInstance = function (clientKey, decryptionKey) {
        if (!Growthbook._instance) {
            Growthbook._instance = new Growthbook(clientKey, decryptionKey);
            return Growthbook._instance;
        }
        return Growthbook._instance;
    };
    Growthbook.prototype.setAttributes = function (_a) {
        var id = _a.id, country = _a.country, user_language = _a.user_language, device_language = _a.device_language, device_type = _a.device_type;
        return this.GrowthBook.setAttributes(__assign(__assign(__assign(__assign({ id: id }, (country !== undefined && { country: country })), (user_language !== undefined && { user_language: user_language })), (device_language !== undefined && { device_language: device_language })), (device_type !== undefined && { device_type: device_type })));
    };
    Growthbook.prototype.getFeatureState = function (id) {
        // @ts-ignore
        return this.GrowthBook.evalFeature(id);
    };
    Growthbook.prototype.getFeatureValue = function (key, defaultValue) {
        // @ts-ignore
        return this.GrowthBook.getFeatureValue(key, defaultValue);
    };
    Growthbook.prototype.setUrl = function (href) {
        return this.GrowthBook.setURL(href);
    };
    Growthbook.prototype.isOn = function (key) {
        // @ts-ignore
        return this.GrowthBook.isOn(key);
    };
    Growthbook.prototype.init = function () {
        this.GrowthBook.loadFeatures().catch(function (err) { return console.error(err); });
    };
    return Growthbook;
}());
exports.Growthbook = Growthbook;
